interface SpinnerProps {
  text?: string;
  centered?: boolean;
}

export function Spinner({ text = 'Loading', centered = false }: SpinnerProps) {
  return (
    <div class={`loading${centered ? ' loading-centered' : ''}`}>
      <span class="spinner" />
      <span>{text}</span>
    </div>
  );
}
